import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { GetTimezonesParams, Timezone } from "@/types/timezones"; // Updated import
import { CustomError } from "@/utils/errors";

import { getTimezones } from "./timezonesApi";

export const TIMEZONE_QUERY_KEY = "timezones";

export const useTimezonesQuery = (
  params?: GetTimezonesParams,
  options?: {
    enabled?: boolean;
    refetchOnWindowFocus?: boolean;
    retry?: number | boolean;
  }
): UseQueryResult<Timezone[], CustomError> => {
  return useQuery<Timezone[], CustomError>({
    queryKey: [TIMEZONE_QUERY_KEY, params],
    queryFn: () => getTimezones(params),
    ...options
  });
};
